import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import useCashDrawer from '../../hooks/hardware/useCashDrawer';
import CashDrawerRegistrationPopup from '../../components/hardware/cashDrawer/CashDrawerRegistrationPopup';
import CashDrawerEditPopup from '../../components/hardware/cashDrawer/CashDrawerEditPopup';
import { cashDrawerColumns } from '../../features/hardware/cashDrawer/cashDrawerColumns';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const CashDrawer = () => {
  const {
    list,
    form,
    showRegistrationModal,
    showEditModal,
    openRegistrationModal,
    closeRegistrationModal,
    fetchCashDrawerById,
    saveCashDrawer,
    toggleStatus,
    fetchAllCashDrawers,
  } = useCashDrawer();

  useEffect(() => {
    fetchAllCashDrawers(); // 🚀 Cargar cajones al montar
  }, []);

  const columns = useMemo(() => cashDrawerColumns, []);

  const getActions = (row: any) => [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => fetchCashDrawerById(row.id),
    },
    {
      key: 'deactivate',
      label: 'Activar/Desactivar',
      onClick: () => toggleStatus(row.id),
    },
  ];

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Cajones de Dinero" /> */}
      <BreadcrumbTwo />


      <UniversalRecordTable
        columns={columns}
        data={list}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        onPageChange={() => {}}
        onPageSizeChange={() => {}}
        noDataMessage="No hay cajones de dinero registrados."
        topRightAction={{
          label: 'Nuevo Cajón',
          onClick: openRegistrationModal,
        }}
      />

      <CashDrawerRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeRegistrationModal}
        onSave={() => saveCashDrawer(form)}
      />

      <CashDrawerEditPopup
        isOpen={showEditModal}
        onUpdate={() => saveCashDrawer(form)}
      />
    </DefaultLayout>
  );
};

export default CashDrawer;
